<section (click)="toggleDetails($event)">
  <header [ngClass]="variantColor">
    <div class="description_container">
      <i [class.icon_rotate]="isOpen" class="fas fa-chevron-right"></i>
      <h3>{{ nameCollection + " " + typeCollection }}</h3>
    </div>
    <div
      ngbDropdown
      class="button_action"
      container="body"
      [autoClose]="true"
      placement="right-top right-bottom left-top left-bottom"
    >
      <button
        ngbDropdownToggle
        (click)="stopEvent($event)"
        title="Personalizar Panel"
      >
        <i class="fa fa-fw fa-bars fa-1 icon_menu"></i>
      </button>
      <div ngbDropdownMenu class="gl-custom-dropdown treetable-dropdown">
        <!-- No funca visualmente para mi -->
        <ng-container *appHasPermission="'multiscreen_module'">
          <div *ngIf="!isUnassigned()" ngbDropdownItem (click)="showMultiview()">
            <span class="btn-label"> Ver en Multipantalla </span>
          </div>
        </ng-container>

        <!-- Esto es para editar -->
        <ng-container *appHasPermission="'vehicles_team_update'">
          <div
            *ngIf="!isUnassigned()"
            ngbDropdownItem
            (click)="showEditGroup()"
          >
            <span class="btn-label"
              >Editar
              {{ variant === "operacion" ? "operación" : variant }}</span
            >
          </div>
        </ng-container>

        <!-- Ocultar unidades -->
        <div ngbDropdownItem (click)="changeDisplay()">
          <span class="btn-label">
            {{ isDisplay ? "Ocultar" : "Mostrar" }}
            {{
              isUnassigned()
                ? "unidades sin " +
                  (variant === "operacion" ? "operación" : variant)
                : variant === "operacion"
                ? "operación"
                : variant
            }}</span
          >
        </div>

        <!-- Este es eliminar -->
        <ng-container *appHasPermission="'vehicles_team_delete'">
          <div *ngIf="!isUnassigned()" ngbDropdownItem (click)="showDelete()">
            <span class="btn-label"
              >Descomponer
              {{ variant === "operacion" ? "operación" : variant }}</span
            >
          </div>
        </ng-container>
      </div>
    </div>
  </header>
  <main *ngIf="isOpen">
    <ng-content></ng-content>
  </main>
</section>
